import React from 'react';
import ReactDOM from 'react-dom';
import './VerificationModal.css';

export default function VerificationModal({
  show,
  onClose,
  code,
  onCodeChange,
  onVerify,
  onResend,
  secondsLeft,
  verifying,
  verified,
  error
}) {
  if (!show) return null;

  // Render the overlay/content into document.body instead of inline
  return ReactDOM.createPortal(
    <div className="booking-modal-overlay" onClick={onClose}>
      <div className="booking-modal-content" onClick={e => e.stopPropagation()}>
        <div className="booking-modal-icon">✉️</div>
        <h3>Email Verification</h3>
        <p>Please enter the verification code sent to your email</p>
        <div className="field-group" style={{ marginBottom: '1.5rem' }}>
          <input
            type="text"
            placeholder="Enter 6-digit code"
            value={code}
            onChange={e => onCodeChange(e.target.value)}
            style={{ 
              textAlign: 'center', 
              fontSize: '1.2rem', 
              letterSpacing: '0.3rem',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #dee2e6',
              width: '100%'
            }}
          />
        </div>
        {error && <small className="error" style={{ display: 'block', textAlign: 'center', color: '#dc3545', marginBottom: '1rem' }}>{error}</small>}
        <div className="booking-modal-actions">
          <button
            onClick={onVerify}
            disabled={verifying || verified}
            className="booking-btn-modal"
          >
            {verifying ? 'Verifying…' : verified ? '✓ Verified' : 'Verify Code'}
          </button>
          <button
            onClick={onResend}
            disabled={secondsLeft > 0}
            className="booking-btn-modal secondary"
          >
            {secondsLeft > 0 ? `Resend in ${secondsLeft}s` : 'Resend Code'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
